// @ts-check
import { getStore } from 'shared/stash';
import Services from 'agent_portal/services';

const REQUESTING_REFERRAL_QUESTIONNAIRE = 'REQUESTING_REFERRAL_QUESTIONNAIRE';
const RECEIVE_REFERRAL_QUESTIONNAIRE = 'RECEIVE_REFERRAL_QUESTIONNAIRE';
const SAVING_REFERRAL_QUESTIONNAIRE = 'SAVING_REFERRAL_QUESTIONNAIRE';
const SAVED_REFERRAL_QUESTIONNAIRE = 'SAVED_REFERRAL_QUESTIONNAIRE';

export { RECEIVE_REFERRAL_QUESTIONNAIRE };

const actions = {
  requestingReferralQuestionnaire(payload) {
    return getStore().dispatch({ type: REQUESTING_REFERRAL_QUESTIONNAIRE, payload });
  },

  receiveReferralQuestionnaire(payload) {
    return getStore().dispatch({ type: RECEIVE_REFERRAL_QUESTIONNAIRE, payload });
  },

  savingReferralQuestionnaire(payload) {
    return getStore().dispatch({ type: SAVING_REFERRAL_QUESTIONNAIRE, payload });
  },

  savedReferralQuestionnaire(payload) {
    return getStore().dispatch({ type: SAVED_REFERRAL_QUESTIONNAIRE, payload });
  },

  fetchQuestionnaire(referralProfileId) {
    actions.requestingReferralQuestionnaire();
    Services.Questionnaire.fetchQuestionnaire(
      `/agent_portal/api/referral_profiles/${referralProfileId}/referral_questionnaire/edit.json`
    ).then(data => {
      actions.receiveReferralQuestionnaire({
        referralProfileId,
        referralQuestionnaire: data.serializedReferralQuestionnaire,
        patientName: data.patientName,
        referralProfile: data.referralProfile,
        rulableReferralProfileValues: data.rulableReferralProfileValues,
      });
    });
  },

  submitReferralQuestionnaire(referralProfileId, questionnaire) {
    actions.savingReferralQuestionnaire();
    return Services.Questionnaire.saveQuestionnaire(
      `/agent_portal/api/referral_profiles/${referralProfileId}/referral_questionnaire`,
      questionnaire
    ).then(response => {
      actions.savedReferralQuestionnaire();
      return response;
    });
  },
};

export default actions;
